import React, {useState, useContext, useEffect} from 'react';
import axios from 'axios';
import moment from "moment";
import {Link, useHistory, useParams} from 'react-router-dom';
import {Alert, Button, Col, Form, Row, Card, OverlayTrigger, Tooltip} from 'react-bootstrap';
import {useLocalStorage} from 'react-use';
import AuditContext from '../Utils/context.js';
import {ACTIONS} from '../Utils/action';
import {useAlert, TYPES} from 'hooks/use-alert-hook.js';

import AuditAuditorFinding from './Finding.js';

export default function Evaluation() {

  const disabledStatus = [
    'EVALUATED',
    'VISITED',
    'APPROVED',
    'COMPLETED'
  ];

  const {employeeId} = useParams();
  const {schedule, dispatchSchedule} = useContext(AuditContext);
  const [showEvaluate, setShowEvaluate] = useState(schedule.SHOW_EVALUATE);

  const history = useHistory();
  const [auth] = useLocalStorage('authenticated');
  const [swal, setSwal] = useAlert();

  const getVariant = (form) => {

    switch (true) {
      case (form?.EVALUATE_AT !== null && form?.EVALUATE_BY !== null):
        return 'success';
      case (form?.SUBMIT_AT !== null && form?.SUBMIT_BY !== null):
        return 'primary';
      default:
        return 'secondary';
    }
  }

  const handleFinish = () => {

    try {

      // before submit validation
      if (schedule.forms.find(form => form.EVALUATE_AT === null)) {
        setSwal({
          type: TYPES.ERROR,
          payload: {
            title: `Failed!`,
            message: `There is one or more form not evaluated, yet!`,
          }
        });

        return false;
      }

      const onSuccessCallback = async () => {

        const response = await axios.put(
          `${process.env.REACT_APP_API_HOST}schedules/${schedule.SCHEDULE_ID}`,
          {
            EVALUATE_AT: moment().format('DD-MM-YYYY hh:mm:ss'),
            EVALUATE_BY: auth.employee.EMP_ID,
            SCHEDULE_STATUS: 'EVALUATED',
          },
          {headers: {Authorization: `Bearer ${auth.token}`}}
        );

        dispatchSchedule({
          type: ACTIONS.EDIT,
          payload: {SCHEDULE_STATUS: response.data.SCHEDULE_STATUS},
        });

        history.push(`/auditor/${employeeId}/audits/${schedule.SCHEDULE_ID}/visitations`);

      }

      setSwal({
        type: TYPES.CONFIRM,
        payload: {
          title: `Confirmation!`,
          message: `You won't be able to update it agian in the future.`,
          onSuccess: {
            title: `Success`,
            message: `Submit Success`,
            callback: onSuccessCallback,
          }
        }
      });
    } catch (error) {

      console.log(error);
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const handleChange = (e) => {
    const isChecked = typeof e === 'boolean' ? e : e.target.checked;
    const targetValue = isChecked ? 1 : 0;
    if (e && e.target) {
      e.target.value = targetValue;
    }
    setShowEvaluate(isChecked);
    const response2 = axios.put(
      `${process.env.REACT_APP_API_HOST}schedules/${schedule.SCHEDULE_ID}`,
      {
        SHOW_EVALUATE: targetValue,
      },
      {headers: {Authorization: `Bearer ${auth.token}`}}
    ).catch((error) => {
      console.error('Failed to update:', error);
      setShowEvaluate(!isChecked);
    });
  }

  const handleClick = async (e) => {
    e.preventDefault();
    // return history.push(`/auditor/${auth.employee.EMP_ID}/audits/${schedule.SCHEDULE_ID}/findings`);
    return history.push(`/auditor/${auth.employee.EMP_ID}/audits/${schedule.SCHEDULE_ID}/findings`);
  }

  const findingTooltip = props => (
  <Tooltip {...props}>This is a summary of the auditee's findings</Tooltip>
  );

  const evaluationTooltip = props => (
    <Tooltip {...props}>Enable this switch to allow Auditees to view Evaluations</Tooltip>
  );

  useEffect(() => {
    if(schedule){
      if(schedule.SHOW_EVALUATE === 0){
        let countSubmit = 0
        let lengthCriteria = schedule.forms.length
        schedule.forms.forEach(element => {
          if(element.SUBMIT_AT){
            countSubmit += 1
          }
        });
        if(countSubmit === lengthCriteria){
          handleChange(true)
        }
      }
    }
  }, [schedule]);


  return (
    <>
      {swal}
      <h3>Desk Evaluation</h3>
      <Form.Group>
        <Row>
          {schedule.forms && schedule.forms.map((form, key) => {
            if (form.SUBMIT_BY === null) {
              return (
                <Col key={key}  md={4}>
                  <Link to={`/auditor/${employeeId}/proofs/${form.FORM_ID}`}>
                    <Button variant={getVariant(form)} style={{textAlign: 'left'}}>{form.criteria.CRITERIA_CODE}. {form.criteria.CRITERIA_LABEL}</Button> {' '}
                  </Link>
                </Col>
              );
            } else {
              return (
                <Col key={key}  md={4}>
                  <Link to={`/auditor/${employeeId}/evaluations/${form.FORM_ID}`}>
                    <Button variant={getVariant(form)} style={{textAlign: 'left'}}>{form.criteria.CRITERIA_CODE}. {form.criteria.CRITERIA_LABEL}</Button> {' '}
                  </Link>
                </Col>
              )
            }})}
          </Row>
      </Form.Group>
      <Form.Group>
        {!disabledStatus.includes(schedule.SCHEDULE_STATUS)
        ? <Button onClick={handleFinish}>Finish</Button>
        : <Alert style={{textAlign: 'center'}} variant="info">Evaluation Process has been completed.</Alert>}
      </Form.Group>
      <Form.Group>
        {schedule?.FORM_FILE ? (
          <a
            href={`${process.env.REACT_APP_API_HOST}schedules/${schedule.SCHEDULE_ID}/download`}
            className="btn" style={{backgroundColor:'#003D73'}}
            >
              Download Submitted Spreadsheet
            </a>
            ) : (<p></p>)}
      </Form.Group>
      <h4>Additional Features</h4>
      <Row>
          <Form.Group as={Col}>
                <OverlayTrigger placement="top" overlay={evaluationTooltip}>
                  <Form.Label>Show Evaluation Results</Form.Label>
                </OverlayTrigger>
                  <Form.Check
                    id="custom-switch-11"
                    name="SHOW_EVALUATE"
                    type="switch"
                    className="mb-1"
                    defaultChecked={schedule.SHOW_EVALUATE}
                    checked={Boolean(showEvaluate)}
                    // onChange={e => {
                    //   e.target.value = e.target.checked ? 0 : 1;
                    //   onChange(e);
                    // }}
                    onChange={handleChange}
                    />
          </Form.Group>
          <Form.Group as={Col}>
                <OverlayTrigger placement="top" overlay={findingTooltip}>
                  <Form.Label>Show Finding</Form.Label>
                </OverlayTrigger>
                <Form.Group>
                  <Button onClick={handleClick}>Summary Findings</Button>
                </Form.Group>
          </Form.Group>
          <Form.Group as={Col}></Form.Group>
          <Form.Group as={Col}></Form.Group>
      </Row>
    </>
  );
}